import React from "react";
import { uniqueId } from "lodash";
// material
import {
  Grid,
  Paper,
  Typography,
  Skeleton,
  Box,
  Stack,
  Link,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { Label } from "src/components";
import { fDateShort } from "src/utils/formatTime";
import { capitalize } from "lodash";
// import { Lable, Popover } from "src/components";
// import Icon from "src/utils/icon";
import ShoppingCartRoundedIcon from "@mui/icons-material/ShoppingCartRounded";
import DateRangeRoundedIcon from "@mui/icons-material/DateRangeRounded";
import { Link as RouterLink } from "react-router-dom";
import { fCurrency } from "src/utils/formatNumber";
const RootStyle = styled(Paper)(({ theme }) => ({
  padding: "10px 10px 10px 16px",
  marginBottom: "0.5rem",
  backgroundColor: theme.palette.background.paper,
  border: "1px solid " + theme.palette.divider,
  borderRadius: 4,
  "& .name": {
    fontWeight: 600,
    color: theme.palette.info.main,
  },
  "& .time svg": {
    width: 10,
    height: 10,
    "& path": {
      fill: theme.palette.text.primary,
    },
  },
  "& .date": {
    fontSize: "0.75rem",
    fontWeight: 500,
  },
  "& .callander": {
    "& svg": {
      width: 10,
      height: 10,
    },
  },
  "& .time-slot": {
    fontWeight: 500,
    fontSize: "0.75rem",
  },
  "& .phone-container": {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    gap: "0.5rem",
    "& .phone": {
      color: theme.palette.text.secondary,
      fontWeight: 400,
      fontSize: 11,
    },
    "& .btn-phone": {
      fontSize: "1px",
    },
  },
}));

export default function AgendaCodeMobile({ item, isLoading }) {
  const theme = useTheme();
  const isConsultation = Boolean(item?.consultation || item?.customer);
  const title =
    item?.user?.fullName ||
    item?.customer?.full_name ||
    item?.product?.name ||
    item?.name ||
    "Record";
  const detail =
    item?.items?.length != null
      ? `${item.items.length} item${item.items.length > 1 ? "s" : ""}`
      : item?.product?.name || item?.consultation?.date || "-";
  const date = item?.createdAt || item?.consultation?.date;
  const status =
    item?.status ||
    (typeof item?.is_consulted === "boolean"
      ? item.is_consulted
        ? "consulted"
        : "not consulted"
      : item?.is_active
      ? "active"
      : "inactive");
  const statusColor =
    (status === "delivered" && "success") ||
    (status === "ontheway" && "warning") ||
    (status === "pending" && "info") ||
    (status === "consulted" && "success") ||
    (status === "active" && "success") ||
    "error";

  return (
    <RootStyle
      sx={{
        borderLeft: `6px solid ${
          isLoading
            ? theme.palette.divider
            : theme.palette[statusColor].main
        }`,
      }}
      key={uniqueId()}
    >
      <Grid container alignItems="center">
        <Grid item md={8} sm={8} xs={8}>
          <Stack spacing={0.5}>
            <Link
              className="name"
              component={RouterLink}
              to={`/${isConsultation ? "consultation" : "orders"}/${item?._id}`}
              underline="none"
            >
              {isLoading ? <Skeleton variant="text" /> : capitalize(title)}
            </Link>
            <Stack spacing={1} direction="row" alignItems="center">
              {isLoading ? (
                <Skeleton variant="circular" width={20} height={20} />
              ) : (
                <ShoppingCartRoundedIcon fontSize="small" />
              )}
              <Typography className="time-slot">
                {isLoading ? (
                <Skeleton variant="text" width={50} />
              ) : (
                  detail
              )}
              </Typography>
              {isLoading ? (
                <Skeleton variant="circular" width={20} height={20} />
              ) : (
                <DateRangeRoundedIcon fontSize="small" />
              )}
              <Typography className="date">
                {isLoading ? (
                  <Skeleton variant="text" width={50} />
                ) : (
                  date ? fDateShort(date) : "-"
                )}
              </Typography>
            </Stack>
          </Stack>
        </Grid>

        <Grid item xs={4}>
          <Typography sx={{ textAlign: "right", mb: 0.5 }} variant="body2">
            {isLoading ? (
              <Skeleton variant="text" width={50} sx={{ ml: "auto" }} />
            ) : item?.total != null ? (
              fCurrency(Number(item?.total)).slice(0, -3)
            ) : null}
          </Typography>
          <Box className="phone-container">
            {isLoading ? (
              <Skeleton variant="text" width={50} />
            ) : (
              <Label
                variant={theme.palette.mode === "light" ? "ghost" : "filled"}
                color={statusColor}
              >
                {capitalize(status)}
              </Label>
            )}
          </Box>
        </Grid>
      </Grid>
    </RootStyle>
  );
}
